import { PagedResult } from './PagedResult';
import { QueryModel } from './queryModel';

export class PagingModel {
  responseData: PagedResult = {} as PagedResult;
  responseObj: any[] = [];
  query = new QueryModel();
  pager: number[] = [];
  currentPage = 1;
  totalPages: number = 0;
  sortedBy: string = 'id';
  sortDirection: string = 'des';
}
